
/* styles */
require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-38267dad\",\"scoped\":false,\"hasInlineConfig\":false}!./player.css")

var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./player.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-38267dad\"}!../vue-loader/lib/selector?type=template&index=0!./player.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/player.vue
// module id = 541
// module chunks = 1